<template>
  <div class="container flex-column">
    <div class="header"><h1>Ils nous font confiance</h1></div>

    <div class="slider-container flex-row-space-between">
      <div class="arrow-container flex-column"><img src="../../img/confiance/fleche.svg" class="left-arrow arrow" alt="" @click="prev"></div>

      <div class="logo-list flex-row">
        <hooper ref="carousel" :settings="hooperSettings" :infiniteScroll="true" :itemsToShow="5" :wheelControl="false">
          <slide>
            <div class="slide"><img src="../../img/confiance/logo_assystem.png" alt=""></div>
          </slide>
          <slide>
            <div class="slide"><img src="../../img/confiance/logo_circet.png" alt=""></div>
          </slide>
          <slide>
            <div class="slide"><img src="../../img/confiance/logo_engie.png" alt=""></div>
          </slide>
          <slide>
            <div class="slide"><img src="../../img/confiance/logo_ert.png" alt=""></div>
          </slide>
          <slide>
            <div class="slide"><img src="../../img/confiance/logo_orange.png" alt=""></div>
          </slide>
          <slide>
            <div class="slide"><img src="../../img/confiance/logo_sfr.png" alt=""></div>
          </slide>
          <slide>
            <div class="slide"><img src="../../img/confiance/logo_sncf.png" alt=""></div>
          </slide>
          <slide>
            <div class="slide"><img src="../../img/confiance/logo_sogetrel.png" alt=""></div>
          </slide>
          <slide>
            <div class="slide"><img src="../../img/confiance/logo_tibco.png" alt=""></div>
          </slide>
        </hooper>
      </div>

      <div class="arrow-container flex-column"><img src="../../img/confiance/fleche.svg" class="right-arrow arrow" alt="" @click="next"></div>
    </div>

  </div>
</template>

<script>
    import { Hooper, Slide } from 'hooper';
    import 'hooper/dist/hooper.css';

    export default {
        components: {
            Hooper,
            Slide
        },
        data () {
            return {
                hooperSettings: {
                    'infiniteScroll': true,
                    'wheelControl': false,
                    breakpoints: {
                        1600: {
                            itemsToShow: 7
                        },
                        1400: {
                            itemsToShow: 6
                        },
                        1200: {
                            itemsToShow: 5
                        },
                        1000: {
                            itemsToShow: 4
                        },
                        800: {
                            itemsToShow: 3
                        },
                        600: {
                            itemsToShow: 2
                        },
                        530: {
                            itemsToShow: 1
                        },
                        0: {
                            itemsToShow: 1
                        },
                    }
                }
            }
        },
        methods: {
            prev() {
                this.$refs.carousel.slidePrev();
            },
            next() {
                this.$refs.carousel.slideNext();
            }
        }
    }
</script>

<style scoped>
  .container {
    width: 100%;
  }

  .header {
    background-color: #9fa8bd;
    width: 100%;
    color: white;
  }
  h1 {
    font-size: 50px;
    text-transform: uppercase;
    font-weight: 100;
    margin: 10px;
  }

  .slider-container {
    background-color: #e2e5ec;
    height: 200px;
    width: 100%;
  }
  .arrow-container {
    height: 100%;
    max-width: 100px;
    width: 10%;
    min-width: 30px;
    background-color: #e2e5ec;
    z-index: 50;
  }
  .arrow {
    width: 20px;
    cursor: pointer;
  }
  .left-arrow {
  }
  .right-arrow {
    transform: rotate(180deg);
  }

  .logo-list {
    height: 100%;
    max-width: calc(100% - 180px);
    min-width: calc(100% - 70px);
  }
  .logo-list .slide {
    height: 100%;

    display: flex;
    justify-content: center;
    align-items: center;
  }
  .slide img {
    width: 150px;
    cursor: pointer;
  }

  .logo-list > section:focus {
    outline: none;
  }

  /* Mobile */
  @media (max-width: 500px) {
    h1 {
      font-size: 20px;
    }
    .arrow-container {
      display: none;
    }
    .logo-list {
      width: 100%;
      max-width: 100% !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/accueil/Confiance.vue